// License: PROPRIETARY

// The exclusions endpoint carries the branch in its path:
// POST /api/v2/exclusions/{pid}/{branch}. The server treats the branch value
// "*" as "all the branches of this project", so applying an exclusion
// everywhere is one request rather than one per branch.
//
// That matters beyond convenience: Exclusions.create mutates the exclusion it
// is given - it stringifies content in place - so a loop reusing one object
// would double-encode it on the second call.
export const ALL_BRANCHES = "*"

export const branchForExclusion = (currentBranch, applyToAllBranches) => {
    return applyToAllBranches ? ALL_BRANCHES : currentBranch
}

// Removal goes through DELETE /api/v2/exclusions/{pid}/{branch}/{id}, and the
// server matches the branch in the path against the one the exclusion was
// recorded on. An all-branches exclusion is recorded on "*", so deleting it
// against the branch of the report on screen matches nothing and the exclusion
// survives the Remove button.
//
// A "branch" on an exclusion is how an all-branches one announces itself: the
// server sends the field only for those, and only ever as the marker. An
// ordinary exclusion has no branch of its own - it belongs to the branch of the
// report that carried it, which is the one on screen.
export const branchForRemoval = (currentBranch, exclusion) => {
    return (exclusion && exclusion.branch) || currentBranch
}
